"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxiosInstance = exports.getRandomInteger = exports.runWithRetries = exports.sleep = void 0;
const axios_1 = __importDefault(require("axios"));
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.sleep = sleep;
function runWithRetries(action, config = {
    maxTries: 2,
    retrySleep: 1000,
}) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const maxTries = (_a = config.maxTries) !== null && _a !== void 0 ? _a : 2;
        const retrySleep = (_b = config.retrySleep) !== null && _b !== void 0 ? _b : 1000;
        const trace = (_c = new Error().stack) === null || _c === void 0 ? void 0 : _c.split("\n").slice(5).join("\n");
        let lastError;
        for (let count = 0; count < maxTries; count += 1) {
            try {
                return yield action();
            }
            catch (error) {
                error.message += `\n${trace}`;
                console.log(`Attempt ${count + 1} failed: ${error.message}`);
                lastError = error;
                if (count < maxTries - 1) {
                    yield sleep(retrySleep);
                }
            }
        }
        throw lastError || new Error(`Function failed after ${maxTries} retries: ${lastError === null || lastError === void 0 ? void 0 : lastError.message}`);
    });
}
exports.runWithRetries = runWithRetries;
function getRandomInteger(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}
exports.getRandomInteger = getRandomInteger;
function getAxiosInstance({ baseUrl, timeout = 10000, headers = {}, auth, }) {
    let host = baseUrl;
    let instance;
    instance = axios_1.default.create({
        baseURL: host,
        timeout,
        auth,
        headers: Object.assign({}, headers),
    });
    instance.interceptors.response.use((response) => response, (error) => {
        if (error.response) {
            const serviceError = new Error(JSON.stringify({ data: error.response.data, message: error.message }));
            return Promise.reject(serviceError);
        }
        if (error.request) {
            const serviceError = new Error(error.message +
                ". details: " +
                JSON.stringify({
                    baseURL: error.config.baseURL,
                    url: error.config.url,
                    method: error.config.method,
                    data: error.config.data,
                }, null, 2));
            return Promise.reject(serviceError);
        }
        return Promise.reject(error);
    });
    return instance;
}
exports.getAxiosInstance = getAxiosInstance;
//# sourceMappingURL=tools.js.map